import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'DOMESTIC_TRADE',
    icon: 'menu-domestic-trade',
    label: '内贸业务',
    children: [
      {
        code: 'DOMESTIC_TRADE_CONTRACT',
        icon: 'menu-domestic-purchase-contract',
        label: '内贸采购合同',
        path: '/domestic-trade/purchase-contract',
      },
      {
        code: 'DOMESTIC_TRADE_SALES_CONTRACT',
        icon: 'menu-domestic-sales-contract',
        label: '内贸销售合同',
        path: '/domestic-trade/sales-contract',
      },
      {
        code: 'DOMESTIC_TRADE_PAYMENT',
        icon: 'menu-domestic-payment',
        label: '内贸付款',
        path: '/domestic-trade/payment',
      },
      {
        code: 'DOMESTIC_TRADE_RECEIPT',
        icon: 'menu-domestic-receipt',
        label: '内贸回款',
        path: '/domestic-trade/receipt',
      },
    ],
  },
] satisfies Menu[];
